export enum HeightToWeight {

    LEVEL_1 = 'SD3-',
    LEVEL_2 = 'SD2-',
    LEVEL_3 = 'SD1-',
    LEVEL_4 = 'SD0',
    LEVEL_5 = 'SD1',
    LEVEL_6 = 'SD2',
    LEVEL_7 = 'SD3',
    SEVERE_ACUTE_MALNUTRITION = 'Desnutrición aguda severa',
    MODERATE_ACUTE_MALNUTRITION = 'Desnutrición aguda moderada',
    NORMAL_LEVEL = 'Normal',
    RISK_OF_OVERWEIGHT = 'Riesgo de sobrepeso',
    OVERWEIGHT = 'Sobrepeso',
    OBESITY = 'Obesidad',
    UNKNOWN_LEVEL = 'Unknown'
}
